/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';

interface TestDeliveryModeBadgeSignature {
  Element: HTMLSpanElement;
}

export default class TestDeliveryModeBadge extends Component<TestDeliveryModeBadgeSignature> {
  @service features!: FeaturesService;

  get isEnabled() {
    // TODO: Intended to be just a temporary feature flag check, should be
    // removed once Test Delivery Mode is fully implemented.
    return this.features.isEnabled('test_delivery_mode');
  }
}
